import comp from "./ProductUpdatesV2Modal";
export default comp;
